import { SVGProps } from "react";

export default function DoubleChevronRightIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#252B37", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.66667 4.66666L12 8L8.66667 11.3333M4.66667 4.66666L8 8L4.66667 11.3333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
